import { AllianceSlider } from '../civilisations/Alliance'
import { AxolotlSlider } from '../civilisations/Axolotl'
import { LuminayanSlider } from '../civilisations/Luminayan'
import { PurgamenSlider } from '../civilisations/Purgamen'
import { RazatechSlider } from '../civilisations/Razatech'
import SecondaryLayout from '../layout/secondaryLayout'

const ViewLeaderboard = ({ civilisation }) => {
  return (
    <SecondaryLayout
      pageTitle="Leaderboard"
      secondaryTitle={<SecondaryTitle />}
    >
      {civilisation === 'Alliance' ? (
        <AllianceSlider component="leaderboard" />
      ) : civilisation === 'Purgamen' ? (
        <PurgamenSlider component="leaderboard" />
      ) : civilisation === 'Luminayan' ? (
        <LuminayanSlider component="leaderboard" />
      ) : civilisation === 'Razatech' ? (
        <RazatechSlider component="leaderboard" />
      ) : (
        <AxolotlSlider component="leaderboard" />
      )}
    </SecondaryLayout>
  )
}

const SecondaryTitle = () => (
  <p className="text-white pr-2 text-right">Updated daily @ 8:00 UTC</p>
)

export default ViewLeaderboard
